import { ChangeDetectionStrategy, Component, input } from "@angular/core";

@Component({
  selector: "img-container",
  templateUrl: "./img-container.component.html",
  styleUrl: "./img-container.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ImgContainerComponent {
  // public img = input.required();
}
